<script setup>
import { NuxtLink } from '#components'


import { layoutConfig } from '@layouts'
import { can } from '@layouts/plugins/casl'
import {
  getComputedNavLinkToProp,
  getDynamicI18nProps,
  isNavLinkActive,
} from '@layouts/utils'

const props = defineProps({
  item: {
    type: null,
    required: true,
  },
  isSubItem: {
    type: Boolean,
    required: false,
    default: false,
  },
})
</script>

<template>
  <li
    v-if="can(item.action, item.subject)"
    class="nav-link"
    :class="[{
      'sub-item': props.isSubItem,
      'disabled': item.disable,
      'buttonlink' : item.button
    }]"
  >
    <Component
      :is="item.to ? NuxtLink : 'a'"
      v-bind="getComputedNavLinkToProp(item)"
      :class="{ 'router-link-active router-link-exact-active': isNavLinkActive(item, $router) }"
    >
      <template v-if="item.button">
        <VBtn color="primary">
          <Component
            :is="layoutConfig.app.iconRenderer || 'div'"
            class="nav-item-icon"
            v-bind="item.icon || layoutConfig.verticalNav.defaultNavItemIconProps"
          />
          <VTooltip
            location="top"
            activator="parent"
            close-delay="50"
          >
            {{ $te(item.i18n) ? $t(item.i18n) : $te(item.title) ? $t(item.title) : item.title }}
          </VTooltip>
        </VBtn>
      </template>
      <template v-else>
        <Component
          :is="layoutConfig.app.iconRenderer || 'div'"
          class="nav-item-icon"
          v-bind="item.icon || layoutConfig.verticalNav.defaultNavItemIconProps"
        />
        {{ $te(item.i18n) ? $t(item.i18n) : $te(item.title) ? $t(item.title) : item.title }}
      </template>
    </Component>
  </li>
</template>

<style lang="scss">
.layout-horizontal-nav {
  .nav-link a {
    display: flex;
    align-items: center;
  }

  .buttonlink{
    min-inline-size: auto !important;
  }
}
</style>
